import React, { useState, useEffect } from "react";
import { makeStyles, Button, Modal, Paper } from "@material-ui/core";
import cogoToast from "cogo-toast";

import { validateEmail } from "service/util";

export default (props) => {
  const emptyForm = {
    firstName: "",
    lastName: "",
    email: "",
  };
  const classes = useStyles();
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    setForm(emptyForm);
  }, [props.visible]);

  const handleInputChange = (e) => {
    setForm({
      ...form,
      ...{
        [e.target.name]: e.target.value,
      },
    });
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleSubmit();
    }
  };

  const handleSubmit = () => {
    if (anyFieldEmpty(form)) {
      cogoToast.warn("Please enter all information");
      return;
    }

    // Split emails by comma and trim whitespace
    const emails = form.email.split(',').map(email => email.trim()).filter(email => email !== '');

    // Check if any emails are provided
    if (emails.length === 0) {
      cogoToast.warn("Please enter at least one email");
      return;
    }

    // Check if email limit is exceeded
    if (emails.length > 20) {
      cogoToast.warn("Maximum 20 emails allowed at once");
      return;
    }

    // Validate each email
    const invalidEmails = emails.filter(email => !validateEmail(email));
    if (invalidEmails.length > 0) {
      cogoToast.warn(`Please correct the following invalid email${invalidEmails.length > 1 ? 's' : ''}: ${invalidEmails.join(', ')}`);
      return;
    }

    // If there's only one email, submit it as a single object
    if (emails.length === 1) {
      props.onSubmit({
        email: emails[0],
        status: 'pending',
      });
      return;
    }

    // For multiple emails, create an array of invite objects
    const invites = emails.map(email => ({
      email: email,
      status: 'pending',
    }));

    // Submit the array of invites
    props.onSubmit(invites);
  };

  return (
    <Modal
      open={props.visible}
      onClose={props.onClose}
      className={classes.modal}
    >
      <Paper elevation={0} className={classes.modalPaper}>
        <section className={classes.content}>
          <form className={classes.formContainer} onKeyDown={handleKeyDown}>
            <h3 className={classes.formTitle}>New Invite</h3>

            <label htmlFor="form--email" className={classes.label}>
              <span className={classes.formLabelText}>Email</span>
            </label>

            <textarea
              id="form--email"
              className={classes.formTextarea}
              name="email"
              value={form.email}
              onChange={handleInputChange}
              placeholder="Enter up to 20 emails separated by commas"
              rows="6"
              required
            />

            <div className={classes.helperText}>
              Enter up to 20 email addresses separated by commas
            </div>
          </form>

          <section
            style={{
              textAlign: "center",
              marginTop: "20px",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              className={classes.actionBtn}
            >
              Send Invite
            </Button>

            <span className={classes.dismisser} onClick={props.onClose}>
              Close
            </span>
          </section>
        </section>
      </Paper>
    </Modal>
  );
};

const useStyles = makeStyles((theme) => ({
  modal: {
    width: "500px",
    maxWidth: "95%",
    margin: "50px auto 0",
  },
  modalPaper: {
    padding: "20px",
  },
  actionBtn: {
    color: "#fff",
    textTransform: "none",
    padding: "10px 50px",
    display: "inline-block",
    margin: "10px auto 0 auto",
  },
  dismisser: {
    display: "inline-block",
    margin: "10px 0",
    cursor: "pointer",
    fontSize: "14px",
    color: "#333",
  },
  formTitle: {
    textAlign: "center",
    fontSize: "22px",
    margin: "10px 0 30px 0",
  },
  label: {
    display: "flex",
  },
  formLabelText: {
    flex: "1",
  },
  formInput: {
    flex: "2",
  },
  formTextarea: {
    flex: "2",
    resize: "vertical",
    minHeight: "80px",
    padding: "8px",
    fontFamily: "inherit",
    fontSize: "14px",
  },
  helperText: {
    fontSize: "12px",
    color: "#666",
    marginTop: "4px",
    width: "100%",
    textAlign: "right",
  },
}));

const anyFieldEmpty = (fields) => {
  if (!fields.email || fields.email.trim() === "") {
    return true;
  }

  return false;
};
